import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import {Navigation} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.akc');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation],

            wrapperClass: 'akc__list',
            slideClass: 'akc__item',

            navigation: {
                prevEl: slider.querySelector('.akc-slider__btn--prev'),
                nextEl: slider.querySelector('.akc-slider__btn--next'),
            },

            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
            },

            spaceBetween: 10,
            watchOverflow: true,
            loop: false,
        });
    });
});
